module.exports = __webpack_public_path__ + "img/mowmow.d7c508c7.webp";